/**
 * Logging Configuration - Simplified
 * Contains only the LogTag enum for filtering
 */

export enum LogTag {
    PDF_EXPORT = 'pdf_export',
    PDF_IMAGES = 'pdf_images',
    PDF_GENERATION = 'pdf_generation',
    DYNAMIC_CANVAS = 'dynamic_canvas',
    FORM_VALIDATION = 'form_validation',
    FORM_SETUP = 'form_setup',
    FORM_SUBMISSION = 'form_submission',
    FORM_CASCADE = 'form_cascade',
    CALCULATIONS = 'calculations',
    AASHTO_CALC = 'aashto_calc',
    GEOGRID_CALC = 'geogrid_calc',
    RAILWAY_CALC = 'railway_calc',
    API_CALLS = 'api_calls',
    DATA_TRANSFORM = 'data_transform',
    REDUX_STATE = 'redux_state',
    UI_INTERACTIONS = 'ui_interactions',
    NAVIGATION = 'navigation',
    STEPPER = 'stepper',
    CHARTS = 'charts',
    PROJECT_SETUP = 'project_setup',
    PROJECT_INFO = 'project_info',
    PROJECT_TYPE = 'project_type',
    UNIT_CONVERSION = 'unit_conversion',
    MATERIAL_DB = 'material_db',
    VALIDATION = 'validation',
    TESTING = 'testing',
    DEBUG = 'debug',
    PERFORMANCE = 'performance',
    CRITICAL = 'critical',
    ERROR_HANDLING = 'error_handling',
    CASCADE_DEBUG = 'cascade_debug',
    UNPAVED_LENG_GEOTEXTILE = 'unpaved_leng_geotextile',
    METHOD_CHANGE = 'method_change',
    PAVED_INPUTS = 'paved_inputs',
    PAVED_DESIGN = 'paved_design',
    RAILWAY_THICKNESS_SAVING = 'railway_thickness_saving',
    AIRPORT = 'airport',
    PAVED = 'paved',
}
